import { render, staticRenderFns } from "./HasDoubleGlazing.vue?vue&type=template&id=2abb03b6&"
import script from "./HasDoubleGlazing.vue?vue&type=script&lang=ts&"
export * from "./HasDoubleGlazing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports